import React from 'react';
import useResponsiveLayout from '../../../../styles/responsive-layout.hook';
import Button from '../../../shared/button/button.container';
import MerchantButtonComponents from './merchant-button.components';

interface MerchantButtonContainerProps {
  text: string;
  handleOnClick: () => void;
}

const { MobileButton, Arrow, StyledText } = MerchantButtonComponents;

const MerchantButton: React.FunctionComponent<MerchantButtonContainerProps> = ({
  text,
  handleOnClick
}) => {
  const { isMobile, isDesktop } = useResponsiveLayout();

  return (
    <>
      {isMobile && (
        <MobileButton onClick={handleOnClick}>
          <StyledText tParams={text} />
          <Arrow />
        </MobileButton>
      )}
      {isDesktop && (
        <Button type="large" text={text} handleOnClick={handleOnClick} />
      )}
    </>
  );
};

export default MerchantButton;
